import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '@core/services/dialog.service';
import { NotificationService } from '@core/services/notification.service';
import { PatientWrapperService } from '@core/services/service-wrappers/patient-wrapper.service';
import { VisitWrapperService } from '@core/services/service-wrappers/visit-wrapper.service';
import { DialogContent } from 'components';
import { ProcedureTransactionDetailsViewModel } from 'data';
import { map, take } from 'rxjs';
import { SplitVisitComponent } from '../split-visit/split-visit.component';

@Component({
  standalone: false,
  selector: 'app-visit-rules',
  templateUrl: './visit-rules.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./visit-rules.component.scss']
})
export class VisitRulesComponent implements OnInit {
  dataSource: any;
  visitId;
  rules;

  displayedColumns: string[] = ['type', 'subtype', 'criteria', 'result', 'description'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SplitVisitComponent>,
    private visitService: VisitWrapperService
  ) {
    this.rules = data.rules;
    this.dataSource = new MatTableDataSource(this.rules);
  }

  ngOnInit(): void {}
}
